import { useEffect, useState } from "react";
import { api, imgSrc } from "@/lib/api";

let cache = null;

export function useSiteImages() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/site-images")
      .then((r) => { cache = r.data; setMap(r.data); })
      .catch(() => {});
  }, []);
  return map;
}

const LEGACY_CARD_IMAGE_OVERRIDES = {
  "b248f205-4688-46fd-a702-eee2c6005b0a": {
    src: "/images/legacy/home-servico-residencial-480.webp",
    srcSet: "/images/legacy/home-servico-residencial-480.webp 480w, /images/legacy/home-servico-residencial-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 379px",
    width: 960,
    height: 640,
  },
  "e5011344-361d-48de-8914-292cf7c27a38": {
    src: "/images/legacy/home-servico-seguranca-480.webp",
    srcSet: "/images/legacy/home-servico-seguranca-480.webp 480w, /images/legacy/home-servico-seguranca-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 379px",
    width: 960,
    height: 640,
  },
  "771929dc-4d81-4cf9-99bf-f0379b59cd1c": {
    src: "/images/legacy/home-servico-decorativas-480.webp",
    srcSet: "/images/legacy/home-servico-decorativas-480.webp 480w, /images/legacy/home-servico-decorativas-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 379px",
    width: 960,
    height: 640,
  },
  "394ba7ce-804d-4954-a00b-f94402ea9012": {
    src: "/images/legacy/394ba7ce-804d-4954-a00b-f94402ea9012-960.webp",
    srcSet: "/images/legacy/394ba7ce-804d-4954-a00b-f94402ea9012-480.webp 480w, /images/legacy/394ba7ce-804d-4954-a00b-f94402ea9012-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 400px",
    width: 960,
    height: 541,
  },
  "dc1b4346-e075-4ba4-b256-735c284d05de": {
    src: "/images/legacy/dc1b4346-e075-4ba4-b256-735c284d05de-960.webp",
    srcSet: "/images/legacy/dc1b4346-e075-4ba4-b256-735c284d05de-480.webp 480w, /images/legacy/dc1b4346-e075-4ba4-b256-735c284d05de-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 400px",
    width: 960,
    height: 720,
  },
  "9a35bb16-da01-4e1d-bee9-a767f74a54c2": {
    src: "/images/legacy/9a35bb16-da01-4e1d-bee9-a767f74a54c2-960.webp",
    srcSet: "/images/legacy/9a35bb16-da01-4e1d-bee9-a767f74a54c2-480.webp 480w, /images/legacy/9a35bb16-da01-4e1d-bee9-a767f74a54c2-960.webp 960w",
    sizes: "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 400px",
    width: 960,
    height: 720,
  },
};

const CARD_SIZES = "(max-width: 640px) calc(100vw - 40px), (max-width: 1024px) 50vw, 400px";

const RESPONSIVE_LOCAL_OVERRIDES = {
  "/images/residencial-janelas.webp": {
    src: "/images/residencial-janelas.webp",
    srcSet: "/images/residencial-janelas-480.webp 480w, /images/residencial-janelas.webp 1024w",
    sizes: CARD_SIZES, width: 1024, height: 768,
  },
  "/images/empresarial.webp": {
    src: "/images/empresarial.webp",
    srcSet: "/images/empresarial-480.webp 480w, /images/empresarial.webp 1000w",
    sizes: CARD_SIZES, width: 1000, height: 800,
  },
  "/images/automotivo-suv.webp": {
    src: "/images/automotivo-suv.webp",
    srcSet: "/images/automotivo-suv-480.webp 480w, /images/automotivo-suv.webp 1000w",
    sizes: CARD_SIZES, width: 1000, height: 800,
  },
  "/images/seguranca-antiestilhaco.webp": {
    src: "/images/seguranca-antiestilhaco.webp",
    srcSet: "/images/seguranca-antiestilhaco-480.webp 480w, /images/seguranca-antiestilhaco.webp 1200w",
    sizes: CARD_SIZES, width: 1200, height: 900,
  },
  "/images/mesa-tampo.webp": {
    src: "/images/mesa-tampo.webp",
    srcSet: "/images/mesa-tampo-480.webp 480w, /images/mesa-tampo.webp 1000w",
    sizes: CARD_SIZES, width: 1000, height: 800,
  },
};

function legacyCardImageOverride(image) {
  if (!image) return null;
  const id = Object.keys(LEGACY_CARD_IMAGE_OVERRIDES).find((key) => image.includes(key));
  if (id) return LEGACY_CARD_IMAGE_OVERRIDES[id];
  return RESPONSIVE_LOCAL_OVERRIDES[image] || null;
}

export function slot(map, key, fallbackSrc, fallbackAlt) {
  const s = map ? map[key] : null;
  const image = (s && s.image) || fallbackSrc;
  const alt = (s && s.image_alt) || fallbackAlt || "";
  const override = legacyCardImageOverride(image);
  if (override) return { ...override, alt };
  return { src: imgSrc(image), alt };
}

export const HOME_SERVICO_SLOTS = [
  "home-servico-residencial", "home-servico-empresarial", "home-servico-automotivo",
  "home-servico-seguranca", "home-servico-decorativas", "home-servico-mesas",
];

export const PORTFOLIO_SLOTS = {
  Residencial: ["portfolio-residencial-1", "portfolio-residencial-2", "portfolio-residencial-3"],
  Empresarial: ["portfolio-empresarial-1", "portfolio-empresarial-2", "portfolio-empresarial-3"],
  Automotivo: ["portfolio-automotivo-1", "portfolio-automotivo-2"],
  "Mesas e decoração": ["portfolio-mesas-1", "portfolio-mesas-2", "portfolio-mesas-3"],
};

export const SERVICOS_PAGE_SLOTS = [
  "pg-residencial", "pg-empresarial", "pg-automotivo", "pg-seguranca",
  "pg-privacidade", "pg-decorativas", "pg-mesas", "pg-remocao",
];

export const INSTAGRAM_SLOTS = ["instagram-1", "instagram-2", "instagram-3", "instagram-4"];
